// src/admin/pages/OrderSuccess.tsx
import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export const OrderSuccess = () => {
  // Clear the cart from localStorage and sessionStorage on success
  useEffect(() => {
    localStorage.removeItem('cart');
    sessionStorage.removeItem('cart');
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50">
      <div className="bg-white p-8 rounded-lg shadow-md text-center">
        <CheckCircle className="h-12 w-12 text-green-500 mx-auto" />
        <h2 className="mt-4 text-2xl font-semibold text-gray-800">Payment Successful!</h2>
        <p className="mt-2 text-gray-600">Your order has been placed successfully.</p>
        <Link to="/" className="mt-6 inline-block bg-pink-500 text-white px-6 py-2 rounded-lg hover:bg-pink-600">
          Continue Shopping
        </Link>
      </div>
    </div>
  );
};

